import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import DiversityHero from '../components/diversityhero';
import Layout from '../components/layout';
import SEO from '../components/seo';
import { indexMenuLinks } from '../components/_config/menu-links';

const Diversity = ({ data }) => {
  const diversityData = {
    headerText: data.diversity.frontmatter.headerText,
    ctaLabel: data.diversity.frontmatter.cta_label,
    ctaLink: data.diversity.frontmatter.cta_link,
    summary: data.diversity.frontmatter.summary,
  };

  return (
    <Layout menuLinks={indexMenuLinks}>
      <SEO title="Diversity" />
      <DiversityHero data={diversityData} />
    </Layout>
  );
};

Diversity.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Diversity;

export const query = graphql`
  {
    site {
      siteMetadata {
        author
      }
    }

    diversity: markdownRemark(fileAbsolutePath: { regex: "/content/sections/diversity/" }) {
      frontmatter {
        headerText
        cta_label
        cta_link
        summary
      }
    }
  }
`;
